// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 664 ? "reactPlayerPreview" : chunkId) + "." + {"664":"8c7fa93b","787":"952f0a37"}[chunkId] + ".chunk.js";
};